import React from 'react';
import ReactDOM from 'react-dom';
import propTypes from 'prop-types';
import classNames from 'classnames';

import { Overlay, Popover } from 'react-bootstrap';

const baseString = 'vra-popover-trigger';
class PopoverTrigger extends React.Component {
  render() {

    let triggerRef;

    const {
      canCloseOnClickOff=true,
      className,
      popoverIsOpen=false,
      onHideCallback,
      popoverContent,
      popoverClassName,
      popoverPlacement='right',
      popoverName,
      trigger
    } = this.props;

    const classString = classNames({
      [`${baseString}`]: true,
      [`${className}`]: !!className
    });

    const popoverClassString = classNames({
      'popover': true,
      [`${popoverPlacement}`]: true,
      [`${popoverClassName}`]: !!popoverClassName
    });

    const triggerWrapper = (
      <div 
        ref={(tw) => { triggerRef = tw; }}
        onClick={(e) => e.stopPropagation()}>
        {trigger}
      </div>
    );

    const id = `${popoverName}--${popoverPlacement}`;
    const popover = (
      <Overlay
        className={popoverClassString}
        container={triggerRef}
        id='overlay'
        onHide={(e) => onHideCallback(e)}
        placement={popoverPlacement}
        rootClose={canCloseOnClickOff}
        show={popoverIsOpen}
        target={() => ReactDOM.findDOMNode(triggerRef)}>
        <Popover className={popoverClassString} id={id}>
          {popoverContent}
        </Popover>
      </Overlay>
    );

    return (
      <div className={classString}>
        {triggerWrapper}
        {popover}
      </div>
    );
  }
}
PopoverTrigger.defaultProps = {
  onHideCallback: ()=>{}
};
PopoverTrigger.propTypes = {
  canCloseOnClickOff: propTypes.bool,
  className: propTypes.string,
  isPopoverOpen: propTypes.bool,
  onHideCallback: propTypes.func,
  popoverClassName: propTypes.string,
  popoverContent: propTypes.any.isRequired,
  popoverIsOpen: propTypes.bool,
  popoverName: propTypes.string.isRequired,
  popoverPlacement: propTypes.oneOf(['top','bottom','left','right']),
  trigger: propTypes.any.isRequired
};
export default PopoverTrigger;
